(function(){
'use strict';

var PRODUCT_HANDLE='carls-place-pro-enclosure';

var SIZES=['8x10.5','8.5x11','8.5x14.5','9x12','10x13','10x15.5'];
var DEPTHS=['5\'','8\''];
var MATERIALS=['Premium Golf Impact','High-Contrast Gray Golf Impact'];

// Pipe Framing Kit varies by size AND depth
var PIPE_FRAMING={
  '8x10.5':{'5\'':910.00,'8\'':1035.00},
  '8.5x11':{'5\'':945.00,'8\'':1070.00},
  '8.5x14.5':{'5\'':1055.00,'8\'':1180.00},
  '9x12':{'5\'':995.00,'8\'':1120.00},
  '10x13':{'5\'':1055.00,'8\'':1180.00},
  '10x15.5':{'5\'':1135.00,'8\'':1260.00}
};
// These four vary by size only, flat across depth
var BACK_COVER={'8x10.5':675.00,'8.5x11':725.00,'8.5x14.5':905.00,'9x12':795.00,'10x13':880.00,'10x15.5':1005.00};
var BACK_COVER_PIPE={'8x10.5':295.00,'8.5x11':310.00,'8.5x14.5':345.00,'9x12':330.00,'10x13':355.00,'10x15.5':380.00};
var SAFETY_BAFFLE_PRICE=50.00;
var CROSSBAR_PRICE=550.00;

var ACCESSORIES=[
  {handle:'pipe-framing-kit',label:'Pipe Framing Kit',description:'Pre-cut and marked 2" EMT pipe in the exact lengths required — no cutting or hauling required.',dependsOnDepth:true},
  {handle:'back-cover-kit',label:'Back Cover Kit',description:'Eliminates light leak for better image contrast and a polished, professional appearance.',dependsOnDepth:false},
  {handle:'back-cover-pipe-kit',label:'Back Cover Pipe Kit',description:'Pipes needed to mount the back cover kit to your enclosure frame.',dependsOnDepth:false},
  {handle:'safety-baffle',label:'Safety Baffle',description:'Ceiling-hung vinyl strips that help stop high-angle shots and protect ceilings from mishits.',flat:true},
  {handle:'crossbar',label:'Crossbar for Ceiling Accessories',description:'Adjustable mounting solution for launch monitors, projectors, and overhead lighting.',flat:true}
];

var state={material:null,size:null,depth:null,accessories:{},productData:null};

function fmt(n){return '$'+parseFloat(n).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}

function getVariantPrice(material,size,depth){
  if(!state.productData)return 0;
  var v=state.productData.variants.find(function(vv){return vv.options[0]===material&&vv.options[1]===size&&vv.options[2]===depth;});
  return v?parseFloat(v.price)/100:0;
}

function getVariantId(material,size,depth){
  if(!state.productData)return null;
  var v=state.productData.variants.find(function(vv){return vv.options[0]===material&&vv.options[1]===size&&vv.options[2]===depth;});
  return v?v.id:null;
}

function getAccessoryPrice(acc){
  if(acc.flat){
    return acc.handle==='safety-baffle'?SAFETY_BAFFLE_PRICE:CROSSBAR_PRICE;
  }
  if(acc.handle==='pipe-framing-kit'){
    return (state.size&&state.depth&&PIPE_FRAMING[state.size])?PIPE_FRAMING[state.size][state.depth]:0;
  }
  if(acc.handle==='back-cover-kit'){
    return state.size?(BACK_COVER[state.size]||0):0;
  }
  if(acc.handle==='back-cover-pipe-kit'){
    return state.size?(BACK_COVER_PIPE[state.size]||0):0;
  }
  return 0;
}

function totalPrice(){
  var base=(state.material&&state.size&&state.depth)?getVariantPrice(state.material,state.size,state.depth):0;
  var acc=0;
  Object.keys(state.accessories).forEach(function(h){
    var qty=state.accessories[h]||0;
    if(qty>0){
      var a=ACCESSORIES.find(function(x){return x.handle===h;});
      if(a)acc+=qty*getAccessoryPrice(a);
    }
  });
  return base+acc;
}

function buildCSS(){
  var style=document.createElement('style');
  style.textContent=[
    '.sngp-wrap{font-family:inherit;margin:0}',
    '.sngp-section{margin-bottom:22px}',
    '.sngp-section-head{display:flex;align-items:baseline;justify-content:space-between;margin-bottom:10px}',
    '.sngp-section-label{font-size:10px;font-weight:700;letter-spacing:.14em;text-transform:uppercase;color:#555}',
    '.sngp-section-helper{font-size:12px;color:#368ADD;cursor:pointer;text-decoration:underline}',
    '.sngp-mat-select{width:100%;padding:11px 14px;border:1px solid #d0d5dd;border-radius:8px;font-size:13px;font-weight:600;color:#333;background:#fff url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'12\' height=\'12\' viewBox=\'0 0 12 12\'%3E%3Cpath d=\'M2 4l4 4 4-4\' stroke=\'%23555\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3E%3C/svg%3E") no-repeat right 14px center;-webkit-appearance:none;appearance:none;cursor:pointer;transition:border-color .15s}',
    '.sngp-mat-select:focus{outline:none;border-color:#368ADD;box-shadow:0 0 0 2px rgba(54,138,221,.15)}',
    '.sngp-btns{display:flex;flex-wrap:wrap;gap:8px}',
    '.sngp-btn{padding:10px 18px;border:1px solid #d0d5dd;border-radius:8px;background:#fff;color:#333;font-size:13px;font-weight:600;cursor:pointer;transition:all .15s;min-width:72px;text-align:center}',
    '.sngp-btn:hover{border-color:#368ADD;color:#368ADD}',
    '.sngp-btn.active{border-color:#368ADD;background:#f0f6ff;color:#368ADD;box-shadow:0 0 0 1px #368ADD}',
    '.sngp-cascade{display:none;animation:sngpSlideIn .25s ease}',
    '.sngp-cascade.visible{display:block}',
    '@keyframes sngpSlideIn{from{opacity:0;transform:translateY(6px)}to{opacity:1;transform:translateY(0)}}',
    '.sngp-acc-list{display:grid;gap:10px}',
    '.sngp-acc-row{display:flex;align-items:center;justify-content:space-between;padding:12px 14px;border:1px solid #e5e7eb;border-radius:8px;background:#f9fafb;gap:12px}',
    '.sngp-acc-info{flex:1;min-width:0}',
    '.sngp-acc-name{font-size:13px;font-weight:600;color:#111;margin-bottom:2px}',
    '.sngp-acc-desc{font-size:11px;color:#888;line-height:1.4}',
    '.sngp-acc-price{font-size:13px;font-weight:700;color:#111;white-space:nowrap;min-width:60px;text-align:right}',
    '.sngp-qty{display:flex;align-items:center;border:1px solid #d0d5dd;border-radius:6px;overflow:hidden;flex-shrink:0}',
    '.sngp-qty-btn{width:32px;height:32px;background:#f5f5f5;border:none;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;color:#555;transition:background .15s}',
    '.sngp-qty-btn:hover{background:#e5e5e5}',
    '.sngp-qty-val{width:32px;text-align:center;font-size:13px;font-weight:600;color:#111;border:none;background:#fff;padding:0;height:32px;line-height:32px}',
    '.sngp-price-row{display:flex;align-items:baseline;gap:10px;margin:16px 0 4px}',
    '.sngp-price-now{font-size:28px;font-weight:900;color:#111}',
    '.sngp-add-btn{width:100%;padding:16px;background:#368ADD;color:#fff;border:none;border-radius:8px;font-size:14px;font-weight:800;letter-spacing:.06em;text-transform:uppercase;cursor:pointer;transition:background .2s;margin-top:8px}',
    '.sngp-add-btn:hover{background:#2a6ab8}',
    '.sngp-add-btn:disabled{background:#ccc;cursor:not-allowed}',
    '.sngp-divider{border:none;border-top:1px solid #f0f0f0;margin:20px 0}'
  ].join('');
  document.head.appendChild(style);
}

function buildHTML(container){
  container.innerHTML=[
    '<div class="sngp-wrap">',
    '<div class="sngp-price-row"><span class="sngp-price-now" id="sngp-price-display">As low as $3,409.95</span></div>',
    '<hr class="sngp-divider">',
    '<div class="sngp-section">',
    '<div class="sngp-section-head"><span class="sngp-section-label">Screen Material <span style="color:#e53e3e">*</span></span><span class="sngp-section-helper">How do I know?</span></div>',
    '<select class="sngp-mat-select" id="sngp-mat-select"><option value="">Choose an Option...</option>',
    MATERIALS.map(function(m){return '<option value="'+m+'">'+m+'</option>';}).join(''),
    '</select></div>',
    '<div class="sngp-cascade" id="sngp-size-section">',
    '<div class="sngp-section">',
    '<div class="sngp-section-head"><span class="sngp-section-label">Enclosure Size <span style="color:#e53e3e">*</span></span><span class="sngp-section-helper">Check size details</span></div>',
    '<div class="sngp-btns">',
    SIZES.map(function(s){return '<button class="sngp-btn" data-size="'+s+'">'+s+'</button>';}).join(''),
    '</div></div></div>',
    '<div class="sngp-cascade" id="sngp-depth-section">',
    '<div class="sngp-section">',
    '<div class="sngp-section-head"><span class="sngp-section-label">Enclosure Depth <span style="color:#e53e3e">*</span></span></div>',
    '<div class="sngp-btns">',
    DEPTHS.map(function(d){return '<button class="sngp-btn" data-depth="'+d+'">'+d+'</button>';}).join(''),
    '</div></div></div>',
    '<div class="sngp-cascade" id="sngp-acc-section">',
    '<div class="sngp-section">',
    '<div class="sngp-section-head"><span class="sngp-section-label">Accessories</span><span class="sngp-section-helper">Which do I need?</span></div>',
    '<div class="sngp-acc-list" id="sngp-acc-list"></div>',
    '</div></div>',
    '<button class="sngp-add-btn" id="sngp-add-btn" disabled>Select options above to continue</button>',
    '</div>'
  ].join('');
}

function renderAccessories(){
  var list=document.getElementById('sngp-acc-list');
  if(!list||!state.size)return;
  list.innerHTML=ACCESSORIES.map(function(a){
    var price=getAccessoryPrice(a);
    var qty=state.accessories[a.handle]||0;
    var sizeLabel=a.flat?'':' ('+state.size+(a.dependsOnDepth&&state.depth?'x'+state.depth.replace('\'',''):'')+')';
    return[
      '<div class="sngp-acc-row" data-acc="'+a.handle+'">',
      '<div class="sngp-acc-info"><div class="sngp-acc-name">'+a.label+sizeLabel+'</div>',
      '<div class="sngp-acc-desc">'+a.description+'</div></div>',
      '<div class="sngp-acc-price">'+fmt(price)+'</div>',
      '<div class="sngp-qty">',
      '<button class="sngp-qty-btn" data-acc="'+a.handle+'" data-dir="-1">&#8722;</button>',
      '<span class="sngp-qty-val" id="sngp-qty-'+a.handle+'">'+qty+'</span>',
      '<button class="sngp-qty-btn" data-acc="'+a.handle+'" data-dir="1">+</button>',
      '</div></div>'
    ].join('');
  }).join('');
  list.querySelectorAll('.sngp-qty-btn').forEach(function(btn){
    btn.addEventListener('click',function(){
      var h=btn.dataset.acc;
      var dir=parseInt(btn.dataset.dir);
      state.accessories[h]=Math.max(0,(state.accessories[h]||0)+dir);
      document.getElementById('sngp-qty-'+h).textContent=state.accessories[h];
      updatePrice();
    });
  });
}

function updatePrice(){
  var el=document.getElementById('sngp-price-display');
  if(!el)return;
  if(!state.material){el.textContent='As low as $3,409.95';return;}
  if(state.material&&!state.size){
    var minPrice=Math.min.apply(null,SIZES.map(function(s){
      return Math.min.apply(null,DEPTHS.map(function(d){return getVariantPrice(state.material,s,d)||999999;}));
    }));
    el.textContent='As low as '+fmt(minPrice);return;
  }
  if(state.material&&state.size&&!state.depth){
    var minPriceDepth=Math.min.apply(null,DEPTHS.map(function(d){return getVariantPrice(state.material,state.size,d)||999999;}));
    el.textContent='As low as '+fmt(minPriceDepth);return;
  }
  el.textContent=fmt(totalPrice());
}

function updateAddBtn(){
  var btn=document.getElementById('sngp-add-btn');
  if(!btn)return;
  if(state.material&&state.size&&state.depth){btn.disabled=false;btn.textContent='Add to Cart';}
  else if(state.material&&state.size){btn.disabled=true;btn.textContent='Select an enclosure depth';}
  else if(state.material){btn.disabled=true;btn.textContent='Select an enclosure size';}
  else{btn.disabled=true;btn.textContent='Select options above to continue';}
}

function addToCart(){
  var variantId=getVariantId(state.material,state.size,state.depth);
  if(!variantId)return;
  var items=[{id:variantId,quantity:1}];
  var btn=document.getElementById('sngp-add-btn');
  btn.disabled=true;btn.textContent='Adding...';
  fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items:items})})
  .then(function(r){return r.json();})
  .then(function(){
    btn.textContent='Added!';btn.style.background='#1a7a3f';
    setTimeout(function(){
      btn.disabled=false;btn.textContent='Add to Cart';btn.style.background='';
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      var cartIcon=document.querySelector('[data-cart-toggle], .cart-icon-btn, [href="/cart"]');
      if(cartIcon)cartIcon.click();
    },1500);
  })
  .catch(function(){btn.disabled=false;btn.textContent='Add to Cart';});
}

function resetSize(){
  state.size=null;state.depth=null;state.accessories={};
  document.querySelectorAll('#sngp-size-section .sngp-btn').forEach(function(b){b.classList.remove('active');});
  document.querySelectorAll('#sngp-depth-section .sngp-btn').forEach(function(b){b.classList.remove('active');});
  document.getElementById('sngp-depth-section').classList.remove('visible');
  document.getElementById('sngp-acc-section').classList.remove('visible');
}

function init(){
  if(!window.location.pathname.includes(PRODUCT_HANDLE))return;
  buildCSS();
  fetch('/products/'+PRODUCT_HANDLE+'.js')
  .then(function(r){return r.json();})
  .then(function(data){
    state.productData=data;
    var mount=document.getElementById('sng-pro-enclosure-selector-mount');
    if(!mount)return;
    buildHTML(mount);

    var matSelect=document.getElementById('sngp-mat-select');
    matSelect&&matSelect.addEventListener('change',function(){
      state.material=matSelect.value||null;
      resetSize();
      var sizeSection=document.getElementById('sngp-size-section');
      if(state.material){sizeSection&&sizeSection.classList.add('visible');}
      else{sizeSection&&sizeSection.classList.remove('visible');}
      updatePrice();updateAddBtn();
    });

    document.querySelectorAll('#sngp-size-section .sngp-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        state.size=btn.dataset.size;
        state.depth=null;state.accessories={};
        document.querySelectorAll('#sngp-size-section .sngp-btn').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        document.querySelectorAll('#sngp-depth-section .sngp-btn').forEach(function(b){b.classList.remove('active');});
        var depthSection=document.getElementById('sngp-depth-section');
        var accSection=document.getElementById('sngp-acc-section');
        depthSection&&depthSection.classList.add('visible');
        accSection&&accSection.classList.remove('visible');
        updatePrice();updateAddBtn();
      });
    });

    document.querySelectorAll('#sngp-depth-section .sngp-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        state.depth=btn.dataset.depth;
        document.querySelectorAll('#sngp-depth-section .sngp-btn').forEach(function(b){b.classList.remove('active');});
        btn.classList.add('active');
        var accSection=document.getElementById('sngp-acc-section');
        if(accSection){accSection.classList.add('visible');renderAccessories();}
        updatePrice();updateAddBtn();
      });
    });

    var addBtn=document.getElementById('sngp-add-btn');
    addBtn&&addBtn.addEventListener('click',function(){if(!addBtn.disabled)addToCart();});
  })
  .catch(function(e){console.warn('SNG PRO Enclosure Selector error',e);});
}

if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',init);}else{init();}

})();